module.exports = __webpack_public_path__ + "static/media/button.fd0827c7.svg";